module.exports = __webpack_public_path__ + "static/media/logo.3f8b2595.jpeg";